import axios from 'axios'
import store from '@/store'

export async function API(endpoint = '', req = {}) {
  const api_link = store.getters['app/get_api_link']
  const result = await axios.get(`${api_link}/${endpoint}`, req)
  return result
}